/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type SetTestingEnvironmentCommand = {
    /**
     * If true, payment result will not be verified against payment gateway
     */
    enableMockPaymentResult?: boolean;
    /**
     * Payment state to mock, if enabled
     */
    mockPaymentState?: SetTestingEnvironmentCommand.mockPaymentState;
};
export namespace SetTestingEnvironmentCommand {
    /**
     * Payment state to mock, if enabled
     */
    export enum mockPaymentState {
        PENDING = 'PENDING',
        PAID = 'PAID',
        CANCELLED = 'CANCELLED',
        REJECTED = 'REJECTED',
        RETURNED = 'RETURNED',
        PROCESSING = 'PROCESSING',
    }
}

